const bookMap = {
  usabilla: 'https://cdn3.uxfeedback.ru/books/usabilla.pdf',
  intercom: 'https://cdn3.uxfeedback.ru/books/intercom.pdf',
  uxfeedback_voc_guide: 'https://cdn3.uxfeedback.ru/books/uxfeedback_voc_guide.pdf',
  uxfeedback_loyalty_metrics_2023: 'https://cdn.uxfeedback.ru/books/loyalty_newyear_uxfb.pdf'
};

function submitForm (e) {
  e.preventDefault();
  const api = e.target.action;
  const formData = [...(new FormData(e.target).entries())];
  const dataObject = formData.reduce((acc, [key, val]) => ({ ...acc, [key]: val }), { urlUtm: document.location.href });
  const bookName = dataObject.book;

  Object.keys(dataObject).forEach((key) => {
    dataObject[key] = dataObject[key].toLowerCase().replaceAll('>', '&#62;')
    .replaceAll('<', '&#60;')
    .replaceAll('&', '&#38;')
    .replaceAll('eval', '&#101;&#118;&#97;&#108;')
  });

  console.log(bookName)

  if (bookName !== 'uxfeedback_loyalty_metrics_2023') {
    document.querySelector('.modal').classList.add('active');
    document.querySelector('.shadow-bg').classList.add('active');
  }

  window.open(bookMap[bookName])

  fetch(api, {
    method: 'post',
    body: JSON.stringify(dataObject),
    headers: {
      "Content-Type": "application/json"
    }
  }).then(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'frmEmail' });
    this.reset()
  })
};

document.querySelector('.shadow-bg').addEventListener('click', function (e) {
  document.querySelector('.shadow-bg').classList.remove('active');
  document.querySelector('.modal').classList.remove('active');
});

document.querySelector('.close-popup').addEventListener('click', function (e) {
  document.querySelector('.modal').classList.remove('active');
  document.querySelector('.shadow-bg').classList.remove('active');
});

document.querySelector('.demo-form').addEventListener('submit', submitForm);
